import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, {
    to: "body",
    disabled: $setup.props.inline
  }, [
    _createElementVNode("canvas", {
      ref: "canvasRef",
      class: _normalizeClass(["nge-confetti-canvas", { 'nge-confetti-canvas--under': $setup.underUI, 'nge-confetti-canvas--inline': $setup.props.inline }])
    }, null, 2 /* CLASS */)
  ], 8 /* PROPS */, ["disabled"]))
}